/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IRootState } from "../../config/reducers";

type IWrapperStyle = {
  overflow: string;
};

type NotificationWrapperProps = {
  show: boolean;
  hideFilter: () => void;
  dismissAll: () => void;
  children: JSX.Element[] | JSX.Element;
  wrapperStyle?: IWrapperStyle;
};

export const NotificationWrapper: FC<NotificationWrapperProps> = ({
  hideFilter,
  dismissAll,
  children,
  wrapperStyle = { overflow: "auto" },
}) => {
  const { t } = useTranslation();
  const { entities } = useSelector(
    (state: IRootState) => state.notificationReducer
  );
  return (
    <div
      className={`sidebar-collapsed sidebar sidebar-light sidebar-right sidebar-mobile-expanded animated-sidebar fadeIn noti-sidebar`}
    >
      <div className="sidebar-content full-height">
        <div className="sidebar-section sidebar-section-body d-flex align-items-center">
          <h5>{t("general.notifications")}</h5>
          {entities && entities.length > 0 && (
            <div className="ml-auto">
              <Badge
                bg="light"
                className="width-100 cursor-pointer text-black"
                onClick={(e) => {
                  e.preventDefault();
                  dismissAll();
                }}
              >
                {t("button.dismiss_all")}
              </Badge>
            </div>
          )}
          <div className="ml-auto">
            <button
              onClick={() => {
                hideFilter();
              }}
              type="button"
              className="btn btn-outline-light text-body border-transparent btn-icon rounded-pill btn-sm sidebar-control sidebar-right-toggle d-none d-lg-inline-flex"
            >
              <i className="icon-arrow-right8" />
            </button>

            <button
              onClick={() => {
                hideFilter();
              }}
              type="button"
              className="btn btn-outline-light text-body border-transparent btn-icon rounded-pill btn-sm sidebar-mobile-right-toggle d-lg-none"
            >
              <i className="icon-cross2" />
            </button>
          </div>
        </div>
        <div
          className="sidebar-section secondary-sidebar left-sidebar"
          style={wrapperStyle}
        >
          <div className="search-form">{children}</div>
        </div>
      </div>
    </div>
  );
};
